
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation/review",
      function () {
        return require("private-next-pages/bcks/invitation/review.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation/review"])
      });
    }
  